export const kDITokenOwPromotionWindow = 'ow-Promotion-window';
export const kPromotionWindowName = 'promotion';
export const kTesterWindowName = 'tester';
export const kDITokenPromotionWindowScreenAnchor =
  'ow-Promotion-window-screen-anchor';
export const kDITokenOwTesterWindow = 'ow-tester-window';
export const KTesterWindowName = 'tester';